import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from './axios-client';
import { ERRORS } from '../constants';
import {
  UserActivity,
  UserActivityRequest,
} from '../_api/models/user-activity.model';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class UserActivityService {
  async insertUserActivity(
    activity: UserActivityRequest
  ): Promise<ApiResponse<boolean | null>> {
    try {
      const response = await axiosClient.post<ApiResponse<boolean | null>>(
        '/api/user-activity',
        activity
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getActivityResetPasswordToken(
    token: string
  ): Promise<ApiResponse<any>> {
    try {
      const response = await axiosClient.get<ApiResponse<any>>(
        '/api/user-activity/get-activity-reset-password-token/' + token
      );

      return response.data;
    } catch (e: any) {
      if (e.response?.status === 400) throw new Error(ERRORS.tokenExpire);
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getActivityEmailVerificationToken(
    token: string
  ): Promise<ApiResponse<UserActivity | null>> {
    try {
      const response = await axiosClient.get<ApiResponse<UserActivity | null>>(
        '/api/user-activity/get-activity-email-verification-token/' + token
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
